// @ts-nocheck
/* Starter Custom Code - This widget has been modified to display product specification only */
import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import transformContentHtml from "@insite/client-framework/Common/Utilities/transformContentHtml";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
// import Accordion, { AccordionProps } from "@insite/mobius/Accordion"; // Starter Custom Code
import { AccordionSectionPresentationProps, ManagedAccordionSection } from "@insite/mobius/AccordionSection";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import { IconMemo, IconProps } from "@insite/mobius/Icon";
import File from "@insite/mobius/Icons/File";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import parse from "html-react-parser";
import * as React from "react";
import { css } from "styled-components";

/* Starter Custom Code - Start */
import Accordion, { AccordionPresentationProps } from "@insite/mobius/Accordion";
import getAccordionVariantField, { AccordionVariant } from "@store/Framework/Common/Fields/Toolkit/accordionVariant";
import Block from "@store/Library/Components/Toolkit/Block";
import blockFullWidthField from "@store/Library/Components/Toolkit/Block/fields/fullWidth";
import blockMarginField from "@store/Library/Components/Toolkit/Block/fields/margin";
import blockVariantField from "@store/Library/Components/Toolkit/Block/fields/variant";
import blockVariantSideField from "@store/Library/Components/Toolkit/Block/fields/variantSide";
import { ProductDetailsAnchorHeadingStyles } from "@store/Library/Widgets/ProductDetails/ProductDetailsAnchorHeading";
import getWidgetComponent from "@toolkit/Framework/Common/Utilities/getWidgetComponent";
import mergeProps from "@toolkit/Framework/Common/Utilities/mergeProps";

const AnchorHeading = getWidgetComponent("ProductDetails/ProductDetailsAnchorHeading");
/* Starter Custom Code - End */

const enum fields {
    /* Starter Custom Code - Start */
    showInAccordion = "showInAccordion",
    blockFullWidth = "blockFullWidth",
    blockVariant = "blockVariant",
    blockVariantSide = "blockVariantSide",
    blockMargin = "blockMargin",
    style = "style",
    /* Starter Custom Code - End */
}

/* Starter Custom Code - Start */
const accordionVariantField = getAccordionVariantField(fields.style);

type Props = WidgetProps &
    HasProduct & {
        fields: {
            [fields.showInAccordion]: boolean;
            [fields.blockFullWidth]: boolean;
            [fields.blockVariant]: string;
            [fields.blockVariantSide]: string;
            [fields.blockMargin]: string;
            [fields.style]: AccordionVariant;
        };
    };
/* Starter Custom Code - End */

export interface ProductDetailsSpecificationsStyles {
    heading?: ProductDetailsAnchorHeadingStyles;
    // Starter Custom Code
    accordion?: AccordionPresentationProps;
    accordionSection?: AccordionSectionPresentationProps;
}

export const specificationsStyles: ProductDetailsSpecificationsStyles = {}; // Starter Custom Code

const styles = specificationsStyles;

const ProductDetailsSpecifications: React.FC<Props> = ({
    /* Starter Custom Code - Start */
    product: { specifications },
    fields: { showInAccordion, style, blockFullWidth, blockVariant, blockVariantSide, blockMargin },
    /* Starter Custom Code - End */
}) => {
    /* Starter Removed - renderingDocuments */
    /* Starter Removed - renderingAttributes */
    const renderingSpecifications = specifications && specifications.length > 0;
    /* Starter Removed - documentsFirst */
    /* Starter Removed - attributesFirst */

    /* Starter Custom Code - Start */
    const accordionStyles = React.useMemo(() => {
        return mergeProps<ProductDetailsSpecificationsStyles>(styles, {
            accordionSection: accordionVariantField.parse(style),
        });
    }, [styles, style]);
    /* Starter Custom Code - End */

    if (!renderingSpecifications /* Starter Custom Code */) {
        return null;
    }

    /* Starter Removed - documentsAccordion */

    /* Starter Removed - attributesAccordion */

    return (
        <>
            {/* Starter Custom Code - Start */}
            {showInAccordion ? (
                <Accordion headingLevel={2} {...accordionStyles.accordion}>
                    {specifications?.map(specification => (
                        <ManagedAccordionSection
                            title={specification.nameDisplay}
                            key={specification.id.toString()}
                            data-test-selector="productDetails_specifications_specification"
                            {...accordionStyles.accordionSection}
                        >
                            {parse(transformContentHtml(specification.htmlContent), parserOptions)}
                        </ManagedAccordionSection>
                    ))}
                </Accordion>
            ) : (
                <>
                    {specifications?.map(specification => (
                        <Block
                            key={specification.id.toString()}
                            data-test-selector="productDetails_specifications_specification"
                            fullWidth={blockFullWidth}
                            variant={blockVariant}
                            variantSide={blockVariantSide}
                            margin={blockMargin}
                        >
                            <AnchorHeading
                                fields={{ title: specification.nameDisplay }}
                                extendedStyles={styles.heading}
                            />
                            {parse(transformContentHtml(specification.htmlContent), parserOptions)}
                        </Block>
                    ))}
                </>
            )}
            {/* Starter Custom Code - End */}
        </>
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(ProductDetailsSpecifications),
    definition: {
        displayName: "Specification",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
        fieldDefinitions: [
            /* Starter Custom Code - Start */
            {
                name: fields.showInAccordion,
                displayName: "Show In Accordion",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
                tooltip: "Show each specification in accordion",
                sortOrder: 99,
            },
            {
                ...accordionVariantField.definition,
                displayName: "Style",
                fieldType: "Contextual",
                isVisible: x => x.fields.showInAccordion,
            },
            {
                ...blockVariantField,
                name: fields.blockVariant,
                sortOrder: 100,
                isVisible: x => !x.fields.showInAccordion,
            },
            {
                ...blockVariantSideField,
                name: fields.blockVariantSide,
                sortOrder: 101,
                isVisible: (widget, ...args) => {
                    return (
                        (blockVariantSideField.isVisible ? blockVariantSideField.isVisible(widget, ...args) : true) &&
                        !widget.fields.showInAccordion
                    );
                },
            },
            {
                ...blockFullWidthField,
                name: fields.blockFullWidth,
                sortOrder: 103,
                isVisible: x => !x.fields.showInAccordion,
            },
            {
                ...blockMarginField,
                name: fields.blockMargin,
                sortOrder: 104,
                isVisible: x => !x.fields.showInAccordion,
            },
            /* Starter Custom Code - End */
        ],
    },
};

export default widgetModule;
